import { Component, HostListener, OnInit } from '@angular/core';
import { EnvService } from './services/env.service';
import { Title } from '@angular/platform-browser';
import { SharedService } from './services/shared.service';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'chatbot';
  constructor(
    private env: EnvService,
    private _title: Title,
    private _shared: SharedService,
    private auth: AuthService
  ) {
    // Browser tab title comes from environment-style configuration.
    this._title.setTitle(this.env.platform_config.title);
  }

    ngOnInit(){
      let tkn = this._shared.getToken()
      if (tkn != undefined) {
        this.logout();
      }
    }

    logout() {
    const payload = {}; // will be set in future based on functionality during logging out.
    this.auth.logout(payload).subscribe(res => {
      if (res.errCode === 0) {
        // do nothing for now
        this.auth.signout();
      }
    });
  }
}
